export default [
	{ "text": "功能查询管理", "icon":"el-icon-s-home"
		,"child":[
			{ "text": "数据导入", "icon": "el-icon-s-cooperation", "path": "/ImportData" },
			{ "text": "列表类别", "icon": "el-icon-s-cooperation", "path": "/BrandManage" },
		]
	},
]